import { yupResolver } from '@hookform/resolvers/yup';
import { useFieldArray, useForm } from 'react-hook-form';
import { useEffect } from 'react';
import { addAttributesFormSchema } from './add-edit-attributes-form.schema';

export const useAddCustomerAttributesForm = specialTags => {
  const form = useForm({
    resolver: yupResolver(addAttributesFormSchema),
    defaultValues: addAttributesFormSchema.cast({ attributes: specialTags }),
    mode: 'onChange',
  });

  const customerAttributeFields = useFieldArray({
    name: 'attributes',
    control: form.control,
  });

  useEffect(() => {
    form.reset(addAttributesFormSchema.cast({ attributes: specialTags }));
  }, [specialTags, form]);

  return { form, customerAttributeFields };
};
